// extracted by mini-css-extract-plugin
export default {"lib_Table":"DataTable_lib_Table__patez"};